import { Button, MagellanPopup } from "components/atoms";
import { useFormikContext } from "formik";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { PiBroom, PiClock } from "react-icons/pi";
import Popup from "reactjs-popup";
import { PopupActions } from "reactjs-popup/dist/types";
import { BUTTON_VARIANT } from "types/components/button/button.interface";
import { IChildrenProp } from "types/components/components.interface";
import "./PopupTimelineForm.scss";

interface IPopupTimelineFormProps extends IChildrenProp {
  trigger?: JSX.Element;
  onAdd?: (action: PopupActions) => void;
  clearPopupValues: (action: PopupActions) => void;
  header: string;
  showButtons?: boolean;
  disabledOnAdd?: boolean;
}

const PopupTimelineForm = ({
  trigger,
  onAdd,
  clearPopupValues,
  children,
  header,
  showButtons = true,
  disabledOnAdd
}: IPopupTimelineFormProps) => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupActions>(null);

  const onAddClick = async () => {
    onAdd && popupRef.current && onAdd(popupRef.current);
  };

  const onClearClick = () => {
    if (popupRef.current) {
      clearPopupValues(popupRef.current);
    }
  };

  const disabledClearValues = false;

  return (
    <Popup ref={popupRef} modal nested trigger={trigger}>
      <MagellanPopup>
        <MagellanPopup.Header className="justify-center w-80 mb-5">
          {t(header)}
        </MagellanPopup.Header>
        {children}
        {showButtons && (
          <MagellanPopup.BottomButtons>
            <Button
              type="button"
              isClear
              onlyIcon
              onClick={onClearClick}
              disabled={disabledClearValues}
            >
              <Button.Icon icon={<PiBroom />} />
            </Button>
            <Button
              type="button"
              variant={BUTTON_VARIANT.submit}
              disabled={disabledOnAdd}
              onClick={onAddClick}
            >
              <Button.Text text={t("button.add")} />
              <Button.Icon icon={<PiClock />} />
            </Button>
          </MagellanPopup.BottomButtons>
        )}
      </MagellanPopup>
    </Popup>
  );
};

export default PopupTimelineForm; 